import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import { API_URLS } from "../../config/apiUrls";
import CloseIcon from "@mui/icons-material/Close";

// Definindo o tipo explícito para os itens de resposta da API
interface LegalContent {
  type: string;
  content: string;
  version: string;
}

interface CardTermosDeUsoProps {
  onClose: () => void;
}

const CardTermosDeUso: React.FC<CardTermosDeUsoProps> = ({ onClose }) => {
  const [content, setContent] = useState<string>(""); // conteúdo puro da API
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTermosDeUso = async () => {
      try {
        const response = await fetch(API_URLS.legal);
        if (!response.ok) {
          throw new Error("Erro ao buscar os dados.");
        }

        const data: LegalContent[] = await response.json(); // Definindo o tipo aqui

        // Filtrar o item do tipo "TERMS_OF_USE"
        const termosData = data.filter((item) => item.type === "TERMS_OF_USE");
        if (termosData.length > 0) {
          // Encontrar a maior versão
          const latestTermos = termosData.reduce((prev, current) => {
            // Comparar versões (split em números)
            const prevVersion = prev.version.split(".").map(Number);
            const currentVersion = current.version.split(".").map(Number);

            // Comparando versão por versão (major, minor, patch)
            for (let i = 0; i < 3; i++) {
              if (currentVersion[i] > prevVersion[i]) {
                return current;
              } else if (currentVersion[i] < prevVersion[i]) {
                return prev;
              }
            }

            // Se as versões forem iguais, mantém o anterior
            return prev;
          });

          setContent(latestTermos.content); // Atualiza o estado com o conteúdo da maior versão
        }
      } catch (err) {
        setError("Erro ao carregar os Termos de Uso.");
      } finally {
        setLoading(false);
      }
    };

    fetchTermosDeUso();
  }, []);

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", padding: 2 }}>
        <Typography variant="body1">Carregando Termos de Uso...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: "center", padding: 2 }}>
        <Typography variant="body1" color="error">
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: "fixed",
        top: "20%",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "white",
        padding: 3,
        boxShadow: 3,
        borderRadius: 1,
        width: "80%",
        height: "60%",
        zIndex: 999,
        overflowY: "scroll",
      }}
    >
      <IconButton
        edge="end"
        color="inherit"
        onClick={onClose}
        aria-label="close"
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      {/* Usando dangerouslySetInnerHTML para renderizar HTML */}
      <Box
        sx={{
          "& p": { marginBottom: "16px", fontSize: "1rem" },
          "& ul": { marginLeft: "20px" },
          "& li": { fontSize: "1rem", lineHeight: "1.5" },
        }}
        dangerouslySetInnerHTML={{ __html: content }} // Renderizando HTML aqui
      />
      <Box mt={2} display="flex" justifyContent="flex-end">
        <Button onClick={onClose}>Fechar</Button>
      </Box>
    </Box>
  );
};

export default CardTermosDeUso;
